<template>
  <div class="transition content-info">
    <div class="icon-items">
      <BasicIcon
        name="danger"
        active
      />
    </div>

    <BasicText>
      Suspension temporaire du financement des formations sur le budget Plan de développement des compétences (PDC)
    </BasicText>
    <BasicText>
      En l’absence de garantie de financement de la part de l'Etat, un budget prévisionnel trimestriel a été mis en
      place pour financer les formations dans le cadre du PDC de moins de 50 salariés. Etant donné que les fonds
      prévisionnels dédiés au PDC sur les deux premiers trimestres ont été consommés, nous ne sommes pas en mesure
      d'accorder la prise en charge de ces formations pour l’instant.
    </BasicText>
  </div>
</template>

<script setup lang="ts">
  import { BasicText, BasicIcon, BasicLink } from '@designSystem/components'
  import type { CarteEvents } from '@/features/interface/machine-etats/types'
  import { redirectExterne } from '@/features/shared/tools/url'

  const emits = defineEmits<CarteEvents<void>>()

  emits('outChanged', true)
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';

  .icon-items {
    background-color: white;
    color: @warning-500;
    align-self: center;
    margin-bottom: 10px;
    svg {
      fill: @warning-500;
      transform: scale(3);
    }
  }

  .content-info {
    width: 500px;
  }

  @media screen and (max-width: 720px) {
    .content-info {
      width: 100%;
    }
  }
</style>

